import styled from "styled-components";

const DeleteButton = styled.button`
  border: none;
  border-radius: 12px;
  background: #ff2727;
  padding: .5rem 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: 800;
  cursor: pointer;
  transition: .1s;
  font-size: 1.2rem;

  &:hover {
    background: #d71111;
  }

  &:focus {
    outline: none;
  }
`;

export default DeleteButton;